import { FC } from 'react';
import { useUpdatePastPaper, AdminPastPaper } from '@/api/useAdminPastPapers';
import { ContentStatus, CONTENT_STATUS_OPTIONS } from '@/_constants/statusOptions';

type PastPaperStatusSelectProps = {
  pastPaper: AdminPastPaper;
};

const PastPaperStatusSelect: FC<PastPaperStatusSelectProps> = ({ pastPaper }) => {
  const { mutate: updatePastPaper } = useUpdatePastPaper();

  const handleChange = (newStatus: ContentStatus) => {
    updatePastPaper({
      pastPaperId: pastPaper.id,
      updates: { status: newStatus },
    });
  };

  return (
    <select
      value={pastPaper.status}
      onChange={(e) => handleChange(e.target.value as ContentStatus)}
      className="px-2 py-1 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C87941] focus:border-transparent"
    >
      {CONTENT_STATUS_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default PastPaperStatusSelect;
